import React from 'react';
import PropTypes from 'prop-types';
import FieldsetHeader from './FieldsetHeader';
import styles from './Fieldset.scss';

function FieldSet({ label, children, className }) {
  return (
    <div className={`${className} ${styles.root}`}>
      {
        label.length > 0 &&
        <FieldsetHeader title={label} />
      }
      {
        children
      }
    </div>
  );
}

FieldSet.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

FieldSet.defaultProps = {
  label: '',
  className: '',
};

export default FieldSet;
